import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, MapPin, Star, Hotel, Users, Plane, Clock, Utensils, Car } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import BookingModal from '../../components/BookingModal';

const GrandPrixItalie = () => {
  const { language } = useLanguage();
  const [showBookingModal, setShowBookingModal] = useState(false);

  const stayData = {
    id: '73fe3c9d-0f00-440e-91c8-660e68069d60',
    title: "Grand Prix d'Italie",
    title_en: 'Italian Grand Prix',
    date: '4-6 Septembre 2026',
    location: 'Monza, Italie',
    price_member_with_flight: 25000,
    price_member_no_flight: 20000,
    price_non_member_with_flight: 11500,
    price_non_member_no_flight: 6500,
    total_seats: 20,
    seats_sold: 0
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)' }}>
      {/* Hero Section */}
      <section style={{
        position: 'relative',
        height: '500px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          zIndex: 0
        }}>
          <img
            src="https://customer-assets.emergentagent.com/job_4a16d148-a58f-4dee-a32d-adc2ae4e5015/artifacts/9ueiean9_GP%20ITALIE.jpeg"
            alt="Grand Prix Italie"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(255, 254, 242, 0.9))'
          }} />
        </div>

        <div className="container" style={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center'
        }}>
          <Link to="/member/stays" style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '24px',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            fontSize: '14px',
            padding: '8px 16px',
            background: 'rgba(255, 254, 242, 0.9)',
            border: '1px solid var(--border-light)'
          }}>
            <ArrowLeft size={16} />
            {language === 'fr' ? 'Retour aux séjours' : 'Back to stays'}
          </Link>
          
          <h1 className="hero-large" style={{ marginBottom: '16px', color: 'var(--text-primary)' }}>
            {language === 'fr' ? 'Grand Prix d\'Italie 2026' : 'Italian Grand Prix 2026'}
          </h1>
          <h2 className="hero-medium" style={{ 
            marginBottom: '24px',
            color: 'var(--text-secondary)'
          }}>
            Autodromo Nazionale di Monza – Italie
          </h2>
          
          <div style={{
            display: 'flex',
            gap: '24px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Calendar size={20} />
              <span className="body-large">4-6 Septembre 2026</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MapPin size={20} />
              <span className="body-large">Monza, Italie</span>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <p className="body-large" style={{
            lineHeight: 1.8,
            textAlign: 'center',
            marginBottom: '32px'
          }}>
            {language === 'fr' 
              ? "Le Club Henry & Gaby vous propose un week-end prestigieux et une occasion de vous y rendre en jet privé, et d'assister en VIP, dans un cadre magnifique, au plus mythique des Grands Prix de Formule 1."
              : "The Henry & Gaby Club offers you a prestigious weekend and an opportunity to get there by private jet and attend in VIP style, in a magnificent setting, the most legendary Formula 1 Grand Prix."}
          </p>
          
          <h3 className="heading-1" style={{ marginBottom: '16px', textAlign: 'center' }}>
            {language === 'fr' ? 'Présentation du Package H&G – Italie 2026' : 'H&G Package Presentation – Italy 2026'}
          </h3>
          
          <p className="body-regular" style={{
            lineHeight: 1.8,
            color: 'var(--text-secondary)',
            textAlign: 'center',
            marginBottom: '16px'
          }}>
            {language === 'fr'
              ? "Monza est un monument de la F1, avec des hospitalités comparables aux offres premium de SPORTFIVE et F1 Experiences (terrasses, paddock club, gastronomie, open bar)."
              : "The Hungaroring is renowned for its warm atmosphere and high-quality VIP areas, in the spirit of Champions Club or Paddock Club packages offered by F1 Experiences."}
          </p>
          
          <p className="body-regular" style={{
            lineHeight: 1.8,
            color: 'var(--text-secondary)',
            textAlign: 'center'
          }}>
            {language === 'fr'
              ? "Monza, circuit historique de la Formule 1, constitue un cadre privilégié pour des opérations corporate. HLe Grand Prix de Hongrie est reconnu pour la qualité de ses infrastructures d'accueil et son attractivité pour les entreprises. H&G y déploie une offre d'hospitalité premium permettant de combiner efficacité professionnelle et expérience sportive d'exception.G y propose une hospitalité premium alliant excellence gastronomique, confort et visibilité optimale."
              : "The Hungarian Grand Prix is recognized for the quality of its reception infrastructure and its attractiveness for businesses. H&G deploys a premium hospitality offer combining professional efficiency and exceptional sporting experience."}
          </p>
        </div>
      </section>

      {/* Ce que comprend */}
      <section className="section-padding">
        <div className="container" style={{ maxWidth: '1000px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '48px', textAlign: 'center' }}>
            {language === 'fr' ? '✅ Ce que comprend votre expérience H&G' : '✅ What your H&G experience includes'}
          </h2>
          
          <div style={{
            display: 'grid',
            gap: '16px'
          }}>
            {[
              language === 'fr' ? 'Accès VIP dans un espace premium avec vue sur la ligne droite ou la Variante' : 'VIP access in a premium lounge space with strategic view',
              language === 'fr' ? 'Restauration gastronomique italienne' : 'High-end catering (cocktails, gourmet menus)',
              language === 'fr' ? 'Open bar premium' : 'Premium open bar',
              language === 'fr' ? 'Soirée Prestige HSoirée Prestige H&G dans un palace de BudapestG dans un lieu historique près de Milan' : 'H&G Prestige Evening in a Budapest palace',
              language === 'fr' ? 'Accueil personnalisé et assistance dédiée' : 'Personalized welcome and dedicated assistance',
              language === 'fr' ? 'Cadeau VIP H&G' : 'H&G VIP gift',
              language === 'fr' ? 'Option jet privé vers Milan' : 'Private jet option to Budapest',
              language === 'fr' ? 'Organisation complète du séjour (hôtel 5*, transferts, activités)' : 'Complete stay organization (5* hotel, transfers, activities)'
            ].map((item, index) => (
              <div key={index} style={{
                padding: '20px 24px',
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border-light)',
                display: 'flex',
                gap: '16px',
                alignItems: 'center'
              }}>
                <span style={{ color: '#2c5f7d', fontWeight: 'bold', fontSize: '20px' }}>✓</span>
                <span className="body-regular">{item}</span>
              </div>
            ))}
          </div>
          
          <div style={{
            marginTop: '48px',
            padding: '32px',
            background: 'var(--bg-secondary)',
            border: '2px solid var(--text-primary)',
            textAlign: 'center'
          }}>
            <h3 className="heading-1" style={{ marginBottom: '16px' }}>
              {language === 'fr' ? 'Pourquoi Monza ?' : 'Why Monza?'}
            </h3>
            <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              {language === 'fr'
                ? 'La "Pista Magica" : un lieu mythique, une ambiance incomparable, un rendez-vous incontournable pour les passionnés et les entreprises.'
                : 'The "Pista Magica": a legendary place, an incomparable atmosphere, an essential meeting for enthusiasts and companies.'}
            </p>
          </div>
        </div>
      </section>

      {/* Prestation VIP */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '48px', textAlign: 'center' }}>
            {language === 'fr' ? 'Une Prestation VIP' : 'A VIP Service'}
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '24px'
          }}>
            <div style={{
              padding: '28px',
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-light)',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '40px', marginBottom: '16px' }}>✈️</div>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                {language === 'fr' ? 'Vol Jet Privé' : 'Private Jet Flight'}
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {language === 'fr' ? 'Option jet privé depuis Paris' : 'Private jet option from Paris'}
              </p>
            </div>

            <div style={{
              padding: '28px',
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-light)',
              textAlign: 'center'
            }}>
              <Star size={40} style={{ margin: '0 auto 16px', color: '#d4af37' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                {language === 'fr' ? 'Accès VIP Circuit' : 'VIP Circuit Access'}
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {language === 'fr' ? 'Vue sur ligne droite ou Variante' : 'Premium lounge with strategic view'}
              </p>
            </div>

            <div style={{
              padding: '28px',
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-light)',
              textAlign: 'center'
            }}>
              <Hotel size={40} style={{ margin: '0 auto 16px', color: 'var(--text-primary)' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                {language === 'fr' ? 'Hébergement Luxe' : 'Luxury Accommodation'}
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {language === 'fr' ? 'Hôtel 5 étoiles près de Milan' : '5-star hotel in Budapest'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Inclus / Non inclus */}
      <section className="section-padding">
        <div className="container" style={{ maxWidth: '1000px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '32px' }}>
            <div style={{
              padding: '32px',
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-light)'
            }}>
              <h3 className="heading-1" style={{ marginBottom: '24px', color: '#2c5f7d' }}>
                {language === 'fr' ? 'Cette offre INCLUT' : 'This offer INCLUDES'}
              </h3>
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {[
                  language === 'fr' ? 'Accès VIP au Grand Prix' : 'VIP access to Grand Prix',
                  language === 'fr' ? 'Restauration gastronomique et open bar' : 'Gourmet dining and open bar',
                  language === 'fr' ? 'Soirée Prestige H&G' : 'H&G Prestige Evening',
                  language === 'fr' ? 'Hébergement 5 étoiles' : '5-star accommodation',
                  language === 'fr' ? 'Transferts et organisation complète' : 'Transfers and complete organization',
                  language === 'fr' ? 'Cadeau VIP H&G' : 'H&G VIP gift'
                ].map((item, index) => (
                  <li key={index} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                    <span style={{ color: '#2c5f7d', fontWeight: 'bold' }}>✓</span>
                    <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div style={{
              padding: '32px',
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-light)'
            }}>
              <h3 className="heading-1" style={{ marginBottom: '24px', color: '#8b4f6d' }}>
                {language === 'fr' ? 'Cette offre N\'INCLUT PAS' : 'This offer DOES NOT INCLUDE'}
              </h3>
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {[
                  language === 'fr' ? 'Vols commerciaux (hors option jet privé)' : 'Commercial flights (excluding private jet option)',
                  language === 'fr' ? 'Dépenses personnelles' : 'Personal expenses',
                  language === 'fr' ? 'Assurance annulation' : 'Cancellation insurance',
                  language === 'fr' ? 'Activités non mentionnées' : 'Activities not mentioned'
                ].map((item, index) => (
                  <li key={index} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                    <span style={{ color: '#8b4f6d', fontWeight: 'bold' }}>✗</span>
                    <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Info Members Only */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <div style={{
            padding: '32px',
            background: 'var(--bg-primary)',
            border: '1px solid var(--border-light)',
            textAlign: 'center'
          }}>
            <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              {language === 'fr'
                ? "Ce séjour est exclusivement dédié aux membres du Club Henry & Gaby et à leurs Compagnons. Les non-adhérents ne sont admis qu'à titre exceptionnel, sur recommandation d'un membre et dans le respect des conditions tarifaires ci-dessus."
                : "This stay is exclusively dedicated to Henry & Gaby Club members and their Companions. Non-members are only admitted exceptionally, upon recommendation of a member and in compliance with the above pricing conditions."}
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding-small">
        <div className="container" style={{ maxWidth: '600px', textAlign: 'center' }}>
          <h3 className="heading-1" style={{ marginBottom: '16px' }}>
            {language === 'fr' ? 'Réservation' : 'Booking'}
          </h3>
          <p className="body-large" style={{ marginBottom: '24px', lineHeight: 1.7 }}>
            {language === 'fr'
              ? 'Réservez votre place pour ce séjour d\'exception'
              : 'Book your place for this exceptional stay'}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center' }}>
            <button 
              onClick={() => setShowBookingModal(true)} 
              className="btn-primary"
            >
              {language === 'fr' ? 'RÉSERVER' : 'BOOK NOW'}
            </button>
            <Link to="/member/stays" className="btn-secondary">
              {language === 'fr' ? 'Retour aux séjours' : 'Back to stays'}
            </Link>
          </div>
        </div>
      </section>

      <BookingModal
        isOpen={showBookingModal}
        onClose={() => setShowBookingModal(false)}
        item={stayData}
        bookingType="stay"
        onSuccess={() => setShowBookingModal(false)}
      />
    </div>
  );
};

export default GrandPrixItalie;